import src from "IMAGE";
export default { src, width: 318, height: 57, blurWidth: 0, blurHeight: 0};
